// removed by extract-text-webpack-plugin
module.exports = {"o-orderTable":"Qk6wMpdLP5FHic_aXmQzq","o-orderTable__heading":"_1J1q9HTfTnWFLrhsZ67-H-","o-orderTable__row":"_3zHjmiG-jJ_5ol7jUykZsH","o-orderTable__link":"_1cO-xJE1JAOGz84BowWuFw"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderTable/style.scss
// module id = 905
// module chunks = 0